import { createRouter as customCreateRouter } from '../router.js'

import { createRouter as createDefaultRouter, routerOptions } from './defaultRouter'

export function createRouter(ssrContext, config) {
  return customCreateRouter(ssrContext, createDefaultRouter, routerOptions, config)
}
